import React, { useEffect, useRef } from 'react';

const ToolbarPopover = ({
  id,
  open,
  anchorEl,
  onClose,
  title,
  children,
  showCloseButton = false
}) => {
  const popoverRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (open && popoverRef.current && !popoverRef.current.contains(event.target) && !anchorEl?.contains(event.target)) {
        onClose?.();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [open, anchorEl, onClose]);

  return (
    <div className="relative inline-block">
      {open && anchorEl && (
        <div 
          ref={popoverRef}
          className="fixed z-50 mt-2 rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none w-[90vw] sm:w-auto"
          style={{
            left: '50%',
            top: anchorEl.getBoundingClientRect().bottom + 4,
            transform: 'translateX(-50%)',
          }}
          role="menu"
          aria-orientation="vertical"
          aria-labelledby={id}
        >
          <div className="divide-y divide-gray-100">
            <div className="flex justify-between items-center px-4 py-2">
              <h3 className="text-sm font-medium text-gray-900">
                {title}
              </h3>
              {showCloseButton && (
                <button
                  onClick={onClose}
                  className="p-1 rounded-full text-gray-400 hover:bg-gray-100 hover:text-gray-600"
                  aria-label="Close popover"
                >
                  <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path 
                      strokeLinecap="round" 
                      strokeLinejoin="round" 
                      strokeWidth={2} 
                      d="M6 18L18 6M6 6l12 12" 
                    />
                  </svg>
                </button>
              )}
            </div>
            <div>
              {children}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default React.memo(ToolbarPopover);
